import React from 'react'
import {Box, Typography, IconButton, Menu, MenuItem} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {useSelector, useDispatch} from 'react-redux';
import {updateGroup, updateGroupOnReduxAndServer} from '../redux/groupSlice';
import {createItemOnServer, queryServer} from '../api/api';
import { EMPTY_GROUP_ID } from '../constants';
import { LIST_ITEM_BACKGROUND_COLOR } from '../colorPalette';
import { GroupSchema, HeartSchema } from 'lumas-shared-schemas';


function MemberListItem({email, admin, adminMenu=false}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();

    // get group id from the url
    const url = window.location.href;
    const groupID = url.substring(url.lastIndexOf('/') + 1);

    // get group from the redux store
    const group = useSelector((state) => state.group.groups.find((group) => group.id === groupID));

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRemoveClick = async () => {
        // remove the user from the group
        const updatedMembers = group.members.filter((member) => member.email !== email);
        console.log("Updated Members: ", updatedMembers);
        console.log("updated group", {...group, members: updatedMembers});

        // Goal: update the member list from emails to usernames?
        // Problem: we don't have the entire other Member object, only the email
        // Solution 1: Get the user object from the server, update it, then overwrite the DB value with POST '/' route with PutItem
        // Solution 2: write an updateItem command to update only the new attributes of the existing user object 
        // Problem with Solution 2: updating the user.groups attribute requires a list of groups, so we need to get the user object first

        // Update the removed user's object to remove the group from the user.groups list (Solution 1)
        const user = await queryServer(email, 'users');
        const updatedUser = {...user, groups: user.groups.filter((groupID) => groupID !== group.id)};
        await createItemOnServer('users', updatedUser);

        // Remove all hearts from group owned by the removed user
        // Look up all group hearts in DB to get owners; remove from group if owner is the removed user
        const groupHeartIDs = group.hearts;
        let updatedGroupHeartIDs = group.hearts;

        // Problem: async forEach doesn't work as expected; using map() with Promise.all() instead
        const updateHeartPromises = groupHeartIDs.map(async (heartID) => {
            const heart = await queryServer(heartID, 'hearts');
            if (heart.owner === email) {
                // Remove the heart from the group.hearts list
                console.log("Removing heart from group owned by removed user: ", heart.id);
                updatedGroupHeartIDs = updatedGroupHeartIDs.filter((heartID) => heartID !== heart.id); // remove from group
                console.log("Updated group hearts: ", updatedGroupHeartIDs);
        
                // Reset the heart.group to EMPTY_GROUP_ID
                const updatedHeart = HeartSchema.parse({
                    ...heart, 
                    group: EMPTY_GROUP_ID
                });

                // TODO: why is the heart object being created directly in DB, and not in Redux state?
                await createItemOnServer('hearts', updatedHeart);
                console.log("Updated heart to remove group: ", updatedHeart);
            }
        });
        

        await Promise.all(updateHeartPromises); // wait to remove all hearts before dispatching update
        console.log("Updated group hearts when dispatching: ", updatedGroupHeartIDs);

        // Update group object with updated members and groupHeartIDs, validating against GroupSchema
        const updatedGroup = GroupSchema.parse({
            ...group, 
            members: updatedMembers, 
            hearts: updatedGroupHeartIDs
        })

        dispatch(updateGroupOnReduxAndServer({id: groupID, updatedGroup}));

        // close the menu
        handleClose();
    }

    const handleMakeAdminClick = () => {
        // make the user an admin
        console.log("Make Admin: ", email);
        console.log("Group: ", group);

        // make the user an admin and all other members non-admins
        const updatedMembers = group.members.map((member) => member.email === email ? {...member, admin: true} : {...member, admin: false});
        console.log("Updated Members: ", updatedMembers);
        console.log("updated group", {...group, members: updatedMembers});

        // update the group in the redux store, validating against schema
        const updatedGroup = GroupSchema.parse({
            ...group,
            members: updatedMembers
        });
        dispatch(updateGroupOnReduxAndServer({id: groupID, updatedGroup }));

        // close the menu
        handleClose();
    }

    return (
        <Box sx={{marginTop: '5px', width: '100%', height: '35px', backgroundColor: LIST_ITEM_BACKGROUND_COLOR, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Typography sx={{marginLeft: '15px', flexGrow: admin ? 0 : 1}} variant='body2'>{email}</Typography>

            {/* if admin, display 'admin' next to username */}
            {admin && <Typography variant='body2' fontStyle={'italic'} sx={{marginLeft: '20px', flexGrow: 1}}>Admin</Typography>}
            
            {/* Only the admin user can see the menu for non-admin members */}
            {adminMenu && !admin && 
                <IconButton onClick={handleClick}> 
                    <MoreVertIcon />
                </IconButton>
            }   
            {adminMenu && <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                >
                    <MenuItem onClick={handleRemoveClick}>Remove</MenuItem>
                    <MenuItem onClick={handleMakeAdminClick}>Make Admin</MenuItem>
                </Menu>
            }
        </Box>
    )
}

export default MemberListItem